/**
 * Static anatomy cover for the atlas bento card.
 * Full figure, contained so the whole musculature is visible,
 * with a soft #c54d4d glow flowing around the silhouette.
 */
export default function AtlasCoverWidget() {
  return (
    <div className="absolute inset-0 flex items-center justify-center pointer-events-none overflow-hidden">
      {/* Soft color flow / aura behind the figure */}
      <div
        aria-hidden
        className="absolute inset-0"
        style={{
          background: [
            "radial-gradient(ellipse 55% 70% at 50% 48%, rgba(197,77,77,0.38) 0%, rgba(197,77,77,0.16) 42%, transparent 72%)",
            "radial-gradient(ellipse 40% 50% at 42% 40%, rgba(197,77,77,0.22) 0%, transparent 60%)",
            "radial-gradient(ellipse 35% 45% at 58% 58%, rgba(197,77,77,0.18) 0%, transparent 55%)",
          ].join(", "),
        }}
      />
      <img
        src="/notation/muscles-bones-tendons.png"
        alt=""
        aria-hidden
        className="relative z-[1] h-[92%] w-auto max-h-full max-w-[92%] object-contain select-none"
        style={{
          filter: "drop-shadow(0 0 18px rgba(197,77,77,0.45)) drop-shadow(0 0 36px rgba(197,77,77,0.25))",
        }}
        draggable={false}
      />
    </div>
  );
}
